const availableSizes = [380, 480, 580, 680, 780, 800, 980, 1080, 1440, 2048];

const getImageQuality = (pixelRatio: number) => {
  return pixelRatio >= 2 ? 50 : 80;
};

const getClosestSize = (transformSizes: number[], maxDimension: number) => {
  return transformSizes.reduce((prev, curr) => {
    return Math.abs(curr - maxDimension) < Math.abs(prev - maxDimension)
      ? curr
      : prev;
  });
};

const getPixelRatio = () => {
  const pixelRatio = window.devicePixelRatio || 1;

  return pixelRatio > 1 ? 2 : pixelRatio;
};

const getImageTransform = (width: number) => {
  const pixelRatio = getPixelRatio();

  const maxDimension = width * pixelRatio;

  const size = getClosestSize(availableSizes, maxDimension);

  return `${size}q${getImageQuality(pixelRatio)}`;
};

const getExtension = (imageId?: string) => {
  return imageId &&
    imageId.indexOf('.jpg') === -1 &&
    imageId.indexOf('.png') === -1
    ? '.jpg'
    : '';
};

export const getImageSrc = (imageId: string | undefined, width: number) => {
  const extension = getExtension(imageId);

  return imageId?.concat(extension).concat(`?t[]=${getImageTransform(width)}`);
};
